import Alert from '@pelckmans/elementis/components/alert';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useLicenses from '../../../../hooks/useLicenses';
import { useRoutes } from '../../../../hooks/useRoutes';
import ModuleContext from '../../_contexts/ModuleContext';

function DownloadDisclaimer() {
  const { selectedModule } = useContext(ModuleContext);
  const { hasOnlyDemoProductLicenseForTeacher } = useLicenses();

  const { t } = useTranslation();
  const { getRoute } = useRoutes();

  const hasOnlyDemoLicenseForTeacher = hasOnlyDemoProductLicenseForTeacher(selectedModule);

  if (hasOnlyDemoLicenseForTeacher) {
    return (
      <Alert prominence="info" className="modal-content-space-alert-padding-b">
        {t('ALERTS.DOWNLOAD_DISCLAIMER.DEMO_PRODUCT_LICENSE')}
      </Alert>
    );
  }

  return (
    <Alert prominence="info" className="modal-content-space-alert-padding-b">
      <span
        dangerouslySetInnerHTML={{
          __html: t('ALERTS.DOWNLOAD_DISCLAIMER.NO_DOWNLOAD_AVAILABLE', {
            url: getRoute('TERMS_AND_CONDITIONS'),
          }),
        }}
      />
    </Alert>
  );
}

export default DownloadDisclaimer;
